import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskQueuesEditRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-edit',
	path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
	exact: true,
	query: ['config?'],
};
